module.exports = __webpack_public_path__ + "static/img/ios.c52aac93.png";